/* eslint-disable react/prop-types */
import React, {
  Fragment, useState, useEffect, useMemo,
} from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Select,
  Table,
  Drawer,
  Tooltip,
  Popconfirm,
  notification,
  Dropdown,
  Checkbox,
  Tag,
  Switch,
  Popover,
  Image,
  Button,
  Menu,
  Divider,
} from 'antd';
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  CaretDownFilled,
  ControlOutlined,
  FilterOutlined,
  SwapOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ProductActions from '@Actions/productActions';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import OfferActions from '@Actions/offerActions';
import searchIcon from '@Images/icons/icon-search.png';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Helpers from '@Apis/helpers';
import CartActions from '@Actions/cartActions';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import OtherDepartmentsStock from '@Components/Inventory/ManageProducts/ProductsList/OtherDepartmentsStock';
import ProductForm from '@Components/Common/ProductForm';
import { QUANTITY, toISTDate } from '@Apis/constants';
import ZohoBooks from '@Images/admin/integrations/zoho-books.png';
import ShopifyIcon from '@Images/admin/integrations/shopify-icon.png';
import ucIcon from '@Images/icons/unicommerce-icon.png';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import PrintBarcodes from '@Components/Inventory/PrintBarcodes';
import RecentTransactions from '@Components/Inventory/ManageProducts/ViewProduct/RecentTransactions';
import CalculateBulkSp from '@Components/Inventory/ManageProducts/ProductsList/CalculateBulkSp';
import BulkImportProducts from '@Components/Inventory/ManageProducts/ProductsList/BulkImportProducts';
import defaultImage from '@Images/icons/imageDefault.png';
import BulkUpdateProducts from '@Components/Inventory/ManageProducts/ProductsList/BulkUpdateProducts';
import CategoryActions from '@Actions/categoryActions';
import Crown from '@Images/crown2.png';
import { faAnglesRight, faCartPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AddToCartActions from '../../../../actions/addToCart/addToCartActions';
import {
  DefaultColumnsOnViewProduct,
  FixedColumnsOnViewProduct,
  OrderByConfigForListProductScreen,
} from './constants';
import ProductFilterDrawer from './ProductFiltersDrawer';
import AdvanceFilter from '../../../Common/AdvanceFilter';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import { ListScreenKeys } from './mobileListHelper';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';
import { entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import './style.scss';

const { Option } = Select;
const sortConfig = OrderByConfigForListProductScreen;

function ProductsList({
  getCartLoading,
  user,
  getProducts,
  products,
  getProductsLoading,
  cartDataV2,
  syncProductLoading,
  cart,
  getDocCFV2Success,
  syncProduct,
  subCategories,
  getSubCategories,
  history,
  getDocCFV2,
  customFieldsProps,
  getCFV2Loading,
  MONEY,
  addToCartV2,
  addToCartLoadingV2,
  getCartV2,
  departments,
  priceMasking,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [showUpdateProductModal, setShowUpdateProductModal] = useState(false);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [showOtherDepartmentStock, setShowOtherDepartmentStock] = useState(false);
  const [selectedProductSkuId, setSelectedProductSkuId] = useState(false);
  const [selectedProductType, setSelectedProductType] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isUserReady, setIsUserReady] = useState(false);
  const [sortBy, setSortBy] = useState('');
  const [call, setCall] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showSpCalculationDrawer, setShowSpCalculationDrawer] = useState(false);
  const [showPrintBarcodeDrawer, setShowPrintBarcodeDrawer] = useState(false);
  const [marketplaceProduct, setMarketplaceProduct] = useState(false);
  const [showBulkImportDrawer, setShowBulkImportDrawer] = useState(false);
  const [showBulkUpdateProducts, setShowBulkUpdateProducts] = useState(false);
  const [bulkUploadProducts, setBulkUploadProducts] = useState(true);
  const [visible, setVisible] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [openProductFiltersDrawer, setOpenProductFiltersDrawer] = useState(false);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [openAdvanceProductFiltersDrawer, setOpenAdvanceProductFiltersDrawer] = useState(false);
  const [advanceFilters, setAdvanceFilters] = useState('');
  const [uomType, setSecondaryUomType] = useState('');
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [visibleColumns, setVisibleColumns] = useState(
    localStorage.getItem('prcz-page-columns-product')
      ? JSON.parse(localStorage.getItem('prcz-page-columns-product'))
      : DefaultColumnsOnViewProduct,
  );

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const customFieldOptions = useMemo(() => {
    if (customFieldsProps) {
      const data = {
        customFields: [
          ...customFieldsProps?.data?.document_custom_fields,
          ...customFieldsProps?.data?.document_line_custom_fields,
        ],
      };
      const fieldOptions = data?.customFields?.filter((item) => item.is_active);
      return fieldOptions;
    }
  }, [customFieldsProps]);

  const fixedColumns = FixedColumnsOnViewProduct;

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  const isSecondaryUomEnabled = user?.tenant_info?.global_config?.settings?.enable_secondary_uom;

  const departmentLevelVisibility = user?.tenant_info?.inventory_config?.settings?.department_wise_visibility;
  const showOtherDepartmentStockConfig = user?.tenant_info?.inventory_config?.settings
    ?.show_stock_to_other_department;

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || currentPageSize),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'product_type',
        filter_value: Helpers.getValueFromUrl('product_type') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'sort_by',
        filter_value: Helpers.getValueFromUrl('sort_by') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'department_id',
        filter_value: Number(Helpers.getValueFromUrl('department_id')) || null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'marketplace_product',
        filter_value: Boolean(Helpers.getValueFromUrl('marketplace_product')) || false,
        filter_type: filterTypeEnums.BOOLEAN,
      },
      {
        filter_key: 'category',
        filter_value: Helpers.getValueFromUrl('category')
          ?.split(',')
          ?.filter(Boolean)
          ?.map(Number) || [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'advance_filter',
        filter_value: Helpers.getValueFromUrl('advance_filter') || '',
        filter_type: filterTypeEnums.STRING,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'limit',
      filter_value: currentPageSize,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'status',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'product_type',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'sort_by',
      filter_value: 'alter_id_desc',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'department_id',
      filter_value: Number(Helpers.getDepartmentId(user)),
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'marketplace_product',
      filter_value: false,
      filter_type: filterTypeEnums.BOOLEAN,
    },
    {
      filter_key: 'category',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'advance_filter',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.PRODUCTS,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    setSelectedFilterView(systemDefaultUserView);
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (user?.tenant_info?.org_id && savedFilterViews && isUserReadyInitial) {

      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);

      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setKeyword(tempFilterValues.keyword);
        setSearchKeyword(tempFilterValues.keyword);
        setCurrentPageSize(tempFilterValues.limit || currentPageSize);
        setCurrentPage(Number(Helpers.getValueFromUrl('page')) || currentPage);
        setSelectedStatus(tempFilterValues.status);
        setSelectedType(tempFilterValues.product_type);
        setSortBy(tempFilterValues.sort_by);
        setSelectedDepartment(tempFilterValues.department_id);
        setMarketplaceProduct(tempFilterValues.marketplace_product);
        setSelectedCategory(tempFilterValues.category);
        setAdvanceFilters(tempFilterValues.advance_filter);

        setShowAddProductModal(
          Helpers.getValueFromUrl('toCreate')
          && Boolean(Helpers.getValueFromUrl('toCreate')),
        );
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (customFieldsProps?.data?.document_line_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_line_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields
        ?.filter((item) => item?.is_active && !item?.is_system_field)
        ?.map((customField) => {
          columns[customField.cf_id] = {
            label: customField?.field_name,
            visible:
              JSON.parse(localStorage.getItem('prcz-page-columns-product'))?.[
                customField.cf_id
              ]?.visible || false,
          };
        });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  useEffect(() => {
    if (isUserReady) {
      getSubCategories();
      pushParamsToUrl(
        searchKeyword,
        selectedStatus,
        selectedType,
        selectedCategory,
        currentPage,
        currentPageSize,
        sortBy,
        marketplaceProduct,
        selectedDepartment,
        advanceFilters,
        selectedFilterView,
      );

      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());

      getProducts(
        Helpers.getValueFromUrl('keyword') || '',
        user?.tenant_info?.tenant_id,
        Helpers.getValueFromUrl('status') || '',
        Helpers.getValueFromUrl('limit') || currentPageSize,
        Helpers.getValueFromUrl('page') || 1,
        Helpers.getValueFromUrl('tenant_department_id'),
        '',
        Helpers.getValueFromUrl('product_type') || '',
        Helpers.getValueFromUrl('category') || '',
        '',
        '',
        '',
        Helpers.getValueFromUrl('sort_by') || '',
        null,
        null,
        null,
        Helpers.getValueFromUrl('marketplace_product') || false,
        Helpers.getValueFromUrl('department_id'),
        Helpers.getValueFromUrl('advance_filter'),
        true,
      );
      setSelectedRowKeys(null);
      setSelectedRows(null);
    }
  }, [
    searchKeyword,
    selectedStatus,
    selectedType,
    selectedCategory,
    selectedDepartment,
    currentPage,
    currentPageSize,
    sortBy,
    call,
    marketplaceProduct,
    advanceFilters,
    // selectedFilterView,
  ]);

  const displayIntegration = (record) => (
    <Fragment>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '15%' }}>
        {user?.tenant_info?.zoho_branch_id
          && user?.user_tenants?.find(
            (item) => item?.tenant_id === record?.tenant_id,
          )?.zoho_branch_id && (
            <div>
              {record?.zoho_sku_code ? (
                <Tooltip
                  title={`Last sync ${toISTDate(record?.zoho_updated_at).format(
                    'DD/MM/YYYY hh:mm A',
                  )}`}
                  overlayClassName="font-12"
                  placement="topRight"
                >
                  <a
                    href={`https://books.zoho.in/app#/inventory/items/${record?.zoho_sku_code}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="img-zoho__wrapper">
                      <img
                        src={ZohoBooks}
                        alt="Zoho"
                        className="img-zoho"
                      />
                      <div className="green-indicator" />
                    </div>
                  </a>
                </Tooltip>
              ) : (
                <div>
                  <Popconfirm
                    placement="topRight"
                    title={
                      record?.zoho_warning_message === null
                        || record?.zoho_warning_message === ''
                        ? 'This product is not synced with Zoho Books'
                        : `${record?.zoho_warning_message}`
                    }
                    onConfirm={() => syncProduct(
                      { product_sku_id: record?.product_sku_id },
                      () => setCall(!call),
                    )}
                    okText="Sync again"
                    okButtonProps={{
                      loading: syncProductLoading,
                    }}
                    cancelText="Cancel"
                  >
                    <div className="img-zoho__wrapper">
                      <img
                        src={ZohoBooks}
                        alt="Zoho"
                        className="img-zoho img-zoho__disabled"
                      />
                      <div className="green-indicator red-indicator" />
                    </div>
                  </Popconfirm>
                </div>
              )}
            </div>
          )}
        {user?.tenant_info?.shopify_location_id
          && user?.user_tenants?.find(
            (item) => item?.tenant_id === record?.tenant_id,
          )?.shopify_location_id && (
            <div>
              {record?.product_info?.shopify_parent_id && (
                <Tooltip
                  title={`Last sync ${toISTDate(
                    record?.product_info?.shopify_updated_at,
                  ).format('DD/MM/YYYY hh:mm A')}`}
                  overlayClassName="font-12"
                  placement="topRight"
                >
                  <a
                    href={`https://admin.shopify.com/store/${record?.product_info?.shopify_shop_name?.split('.')?.[0]
                      }/products/${record?.product_info?.shopify_parent_id
                      }/variants/${record?.product_info?.shopify_variant_id}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="img-shopify__wrapper">
                      <img
                        src={ShopifyIcon}
                        alt="Shopify"
                        className="img-shopify"
                      />
                      <div className="green-indicator" />
                    </div>
                  </a>
                </Tooltip>
              )}
            </div>
          )}
      </div>
    </Fragment>
  );

  const getProductColumns = () => {
    const inventoryConfig = user?.tenant_info?.inventory_config;
    const globalConfig = user?.tenant_info?.global_config;
    const departmentLevelStock = inventoryConfig?.settings?.department_level_stock;
    const showStockToOtherDepartment = inventoryConfig?.settings?.show_stock_to_other_department;
    const showItemDescription = globalConfig?.settings?.print_description_automatically;
    const DescriptionDisplay = ({ description }) => {
      const isLongDescription = description && description?.length > 50;

      return (
        <div>
          {isLongDescription ? (
            <Tooltip
              color="rgb(234, 242, 254)"
              title={(
                <div
                  style={{ color: 'black', fontSize: '13px' }}
                  className="table-subscript"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
            >
              <div
                className="table-subscript"
                dangerouslySetInnerHTML={{
                  __html: `${description?.substring(0, 50)}...more`,
                }}
              />
            </Tooltip>
          ) : (
            <div
              className="table-subscript"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
      );
    };
    const columns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <div className="mobile-list__item">
      //       <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      //         <Link
      //           to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
      //         >
      //           <H3Text
      //             text={`#${record?.product_info?.internal_sku_code}`}
      //             className="mobile-list__item-number"
      //           />
      //         </Link>
      //         {displayIntegration(record)}
      //       </div>
      //       {record?.product_info && (
      //         <Link
      //           to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
      //         >
      //           <div
      //             className=""
      //             style={{
      //               color: '#000',
      //               fontWeight: '500',
      //               marginTop: '10px',
      //               width: '80%',
      //             }}
      //           >
      //             {record?.product_info?.product_sku_name}
      //           </div>
      //         </Link>
      //       )}

      //       {
      //         <div
      //           style={{
      //             display: 'flex',
      //             marginTop: '10px',
      //             marginBottom: '5px',
      //           }}
      //         >
      //           {record?.product_type?.toUpperCase() !== 'SERVICE' && (
      //             <H3Text
      //               text={`Available Stock - ${QUANTITY(
      //                 record?.store_stock || '0',
      //                 record?.uom_info?.precision,
      //               )} ${record?.uom_info?.uqc?.toProperCase()}`}
      //               className="mobile-list__item-info"
      //             />
      //           )}
      //           <div style={{ marginLeft: 'auto' }}>
      //             {record?.product_type?.toUpperCase() !== 'SERVICE' && (
      //               <H3Text
      //                 text={getStockStatus(record).label}
      //                 className={getStockStatus(record)?.className}
      //               />
      //             )}
      //           </div>
      //         </div>
      //       }
      //       {record.product_type !== 'STORABLE' && record.product_type && (
      //         <div
      //           className="qr__status"
      //           style={{
      //             backgroundColor: Helpers.getProductType(record.product_type)
      //               ?.color,
      //           }}
      //         >
      //           {Helpers.getProductType(record.product_type)?.text}
      //         </div>
      //       )}
      //       {record?.product_info?.unicommerce_sku_code && (
      //         // <Tooltip title={`Last sync ${toISTDate(record?.product_info?.unicommerce_last_sync).format('DD/MM/YYYY hh:mm A')}`} overlayClassName="font-12" placement="topRight">
      //         <img
      //           alt="unicommerce"
      //           className="unicommerce-button"
      //           src={ucIcon}
      //         />
      //         // </Tooltip>
      //       )}
      //     </div>
      //   ),
      //   responsive: ['xs'],
      // },
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link
                // to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                >
                  <PRZText
                    text={`#${record?.product_info?.internal_sku_code}`}
                    className="mobile-list__card_item-number"
                  />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                {record?.product_type?.toUpperCase() !== 'SERVICE' && (
                  <PRZText
                    text={getStockStatus(record).label}
                    className={getStockStatus(record)?.className}
                  />
                )}
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                {record?.product_info && (
                  <div className="mobile-list__card_item-name_wrapper">
                    <Link
                    // to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                    >
                      <PRZText
                        className="mobile-list__card_item-name"
                        text={record?.product_info?.product_sku_name}
                      />
                    </Link>
                  </div>
                )}

                {record?.product_info?.ref_product_code && (
                  <Tooltip
                    title={(
                      <PRZText
                        className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                        text={`Internal SKU#: ${record?.product_info?.ref_product_code}`}
                      />
                    )}
                    color="white"
                  >
                    <PRZText text={`Internal SKU#: ${record?.product_info?.ref_product_code}`} className="mobile-list__card_item-details" />
                  </Tooltip>
                )}

                {user?.tenant_info?.global_config?.sub_modules?.barcoding?.is_active && record?.product_info?.barcode && (
                  <PRZText className="mobile-list__card_item-details" text={`Barcode: ${record?.product_info?.barcode}`} />
                )}

                {record?.category_path?.length > 0 && (
                  <Tooltip
                    title={(
                      <PRZText
                        className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                        text={record?.category_path.join(' / ')}
                      />
                    )}
                    color="white"
                  >
                    <div
                      className="mobile-list__card_item__category__wrapper"
                    >
                      {record?.category_path?.length > 0
                        ? `.../${record?.product_category_name}`
                        : ''}
                    </div>
                  </Tooltip>
                )}
              </div>
              <div className="mobile-list__card_body-right">
                {record?.product_type?.toUpperCase() !== 'SERVICE' && (
                  <Tooltip
                    color="white"
                    placement="top"
                    title={(
                      <PRZText className="mobile-list__card_item__tooltip_text-color" text="Available Stock" />
                    )}
                  >
                    <PRZText
                      text={`${QUANTITY(
                        record?.department_quantity || '0',
                        record?.uom_info?.precision,
                      )} ${record?.uom_info?.uqc?.toProperCase()}`}
                      className="mobile-list__card_item-details"
                    />
                  </Tooltip>
                )}
              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                {record.product_type && (
                  <div
                    className="mobile-list__card_footer__other-status"
                    style={{
                      backgroundColor: Helpers.getProductType(record.product_type)
                        ?.color,
                    }}
                  >
                    {Helpers.getProductType(record.product_type)?.text}
                  </div>
                )}
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedProduct(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        width: '50px',
        className: 'prod-table__image-column',
        render: (record) => (
          <div className="min-width-50">
            {record?.product_info?.assets?.length > 0 ? (
              <Image.PreviewGroup
                items={record?.product_info?.assets?.map((item) => ({
                  src: item?.url,
                }))}
              >
                {record?.product_info?.assets?.map((item, i) => (i === 0 ? (
                  <Image
                    key={item.url}
                    width={40}
                    height={40}
                    src={item?.url}
                    className="product__image"
                  />
                ) : (
                  <Image
                    key={item.url}
                    width={0}
                    height={0}
                    src={item?.url}
                    className="product__image product__image-none"
                  />
                )))}
              </Image.PreviewGroup>
            ) : (
              <img alt="" className="prod-table__image__default" src={defaultImage} />
            )}
          </div>
        ),
        fixed: 'left',
      },
      {
        title: 'SKU#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-50">
            <H3Text text={record?.product_info?.internal_sku_code} />
          </div>
        ),
        className: !visibleColumns?.INTERNAL_SKU_CODE?.visible
          ? 'display-none'
          : '',
        fixed: 'left',
      },
      {
        title: 'INTERNAL SKU#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            {record?.product_info?.ref_product_code}
          </div>
        ),
        className: !visibleColumns?.PRODUCT_REF_CODE?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'PRODUCT NAME',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="product-name__wrapper min-width-100">
            <div className="prod-table__text">
              {record?.product_info?.product_sku_name}
            </div>
            {record.product_type !== 'STORABLE' && record.product_type && (
              <div
                className="qr__status"
                style={{
                  backgroundColor: Helpers.getProductType(record.product_type)
                    ?.color,
                }}
              >
                {Helpers.getProductType(record.product_type)?.text}
              </div>
            )}
            {showItemDescription && (
              <DescriptionDisplay
                description={record?.product_info?.description?.replace(
                  /<[^>]+>/g,
                  '',
                )}
              />
            )}
            {record?.category_path?.length > 0 && (
              <Tooltip
                overlay={(
                  <div className="product-category__tooltip">
                    {record?.category_path.join(' / ')}
                  </div>
                )}
                color="rgb(234, 242, 254)"
              >
                {' '}
                {/* Tooltip wrapping the div */}
                <div
                  className="product-category__wrapper"
                >
                  {/* Displaying only the last category name with ellipsis if path is long */}
                  {record?.category_path?.length > 0
                    ? `.../${record?.product_category_name}`
                    : ''}
                </div>
              </Tooltip>
            )}
            {user?.tenant_info?.global_config?.settings?.marketplace_enabled
              && record.is_marketplace_product && (
                <div
                  className="marketplace__status"
                >
                  Marketplace
                </div>
              )}
          </div>
        ),
        className: !visibleColumns?.PRODUCT_NAME?.visible ? 'display-none' : '',
      },
    ];

    if (
      Helpers.getTenantDepartmentId(user)
      !== user?.tenant_info?.default_store_id
    ) {
      columns.push({
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        title: (
          <React.Fragment>
            <span style={{ fontSize: '12px' }}>AVAILABLE STOCK (Primary)</span>
            {(selectedDepartment === 'all' || !selectedDepartment) && (
              <span style={{ fontSize: '10px', color: '#666' }}>
                (All Departments)
              </span>
            )}
          </React.Fragment>
        ),
        render: (record) => {
          const uomInfo = record?.uom_info;
          const uomList = record?.uom_list;
          const value = record?.department_quantity || 0;
          const quantityInDiffUoms = (
            <div>
              {uomList?.map((uom, i) => (
                <div className="other-uom-stock" key={i}>
                  <div>
                    {QUANTITY(
                      (value * uomInfo?.ratio) / uom?.ratio,
                      uom?.precision,
                    )}
                  </div>
                  <div>{uom?.uqc?.toProperCase()}</div>
                </div>
              ))}
            </div>
          );
          return (
            <div className="min-width-185">
              {['STORABLE', 'BUNDLE'].includes(
                record?.product_type?.toUpperCase(),
              ) ? (
                  <React.Fragment>
                    <Popover
                      placement="bottom"
                      content={quantityInDiffUoms}
                      title="Quantity in other units"
                      trigger="hover"
                    >
                      <div className="available-stock">
                        {`${QUANTITY(
                          value || '0',
                        record?.uom_info?.precision,
                        )} ${record?.uom_info?.uqc?.toProperCase()}`}
                      </div>
                    </Popover>
                  </React.Fragment>
                ) : (
                  '-'
                )}
            </div>
          );
        },
        className: !visibleColumns?.STOCK_IN_STORE?.visible
          ? 'display-none'
          : '',
      });
      if (isSecondaryUomEnabled) {
        columns.push({
          title: (
            <React.Fragment>
              <span style={{ fontSize: '12px' }}>
                AVAILABLE STOCK (Secondary)
              </span>
            </React.Fragment>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          render: (record) => (
            <div className="min-width-200">
              {['STORABLE', 'BUNDLE'].includes(
                record?.product_type?.toUpperCase(),
              ) ? (
                  <React.Fragment>
                    <div className="available-stock">
                      {`${QUANTITY(
                      record?.secondary_available_qty || '0',
                      record?.secondary_uom_info?.precision || 0,
                      )} ${record?.secondary_uom_info?.uqc?.toProperCase() || 'N/A'
                      }`}
                    </div>
                  </React.Fragment>
                ) : (
                  '-'
                )}
            </div>
          ),
          className: !visibleColumns?.SECONDARY_UOM?.visible
            ? 'display-none'
            : '',
        });
      }
      columns.push({
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        title: 'BAD STOCK IN DEFAULT DEPT',
        render: (record) => (
          <div className="min-width-185">
            {record?.product_type?.toUpperCase() === 'STORABLE' ? (
              <React.Fragment>
                <H3Text
                  text={`${QUANTITY(
                    record?.store_rejected_stock || '0',
                    record?.uom_info?.precision,
                  )} ${record?.uom_info?.uqc?.toProperCase()}`}
                />
              </React.Fragment>
            ) : (
              '-'
            )}
          </div>
        ),
        className: !visibleColumns?.REJECTED_STOCK_IN_STORE?.visible
          ? 'display-none'
          : '',
      });
      columns.push({
        title: 'STOCK STATUS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            {['STORABLE', 'BUNDLE'].includes(
              record?.product_type?.toUpperCase(),
            ) ? (
                <H3Text
                  text={getStockStatus(record).label}
                  className={getStockStatus(record)?.className}
                />
              ) : (
                '-'
              )}
          </div>
        ),
        className: !visibleColumns?.STORE_STOCK_STATUS?.visible
          ? 'display-none'
          : '',
      });
    } else if (
      Helpers.getTenantDepartmentId(user)
      === user?.tenant_info?.default_store_id
    ) {
      columns.push({
        title: (
          <React.Fragment>
            <span style={{ fontSize: '12px' }}>AVAILABLE STOCK (Primary)</span>
            {(selectedDepartment === 'all' || !selectedDepartment) && (
              <span style={{ fontSize: '10px', color: '#666' }}>
                (All Departments)
              </span>
            )}
          </React.Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (record) => {
          const uomInfo = record?.uom_info;
          const uomList = record?.uom_list;
          const value = record?.department_quantity || 0;
          const quantityInDiffUoms = (
            <div>
              {uomList?.map((uom, i) => (
                <div className="other-uom-stock" key={i}>
                  <div>
                    {QUANTITY(
                      (value * uomInfo?.ratio) / uom?.ratio,
                      uom?.precision,
                    )}
                  </div>
                  <div>{uom?.uqc?.toProperCase()}</div>
                </div>
              ))}
            </div>
          );
          return (
            <div className="min-width-185">
              {['STORABLE', 'BUNDLE'].includes(
                record?.product_type?.toUpperCase(),
              ) ? (
                  <React.Fragment>
                    <Popover
                      placement="bottom"
                      content={quantityInDiffUoms}
                      title="Quantity in other units"
                      trigger="hover"
                    >
                      <div style={{ cursor: 'pointer' }}>
                        {`${QUANTITY(
                          value || '0',
                        record?.uom_info?.precision,
                        )} ${record?.uom_info?.uqc?.toProperCase()}`}
                      </div>
                    </Popover>
                    {record?.other_department_quantities > 0 && (
                      <H3Text
                        text={`${QUANTITY(
                        record?.other_department_quantities || '0',
                        record?.uom_info?.precision,
                        )} ${record?.uom_info?.uqc?.toProperCase()} in other departments`}
                        className="table-subscript other-dept-stock-subscript"
                        onClick={() => {
                          setShowOtherDepartmentStock(true);
                          setSelectedProductSkuId(record?.product_sku_id);
                          setSelectedProductType(record?.product_type);
                          setSecondaryUomType('primary');
                        }}
                      />
                    )}
                  </React.Fragment>
                ) : (
                  '-'
                )}
            </div>
          );
        },
        className: !visibleColumns?.STOCK_IN_STORE?.visible
          ? 'display-none'
          : '',
      });
      if (isSecondaryUomEnabled) {
        columns.push({
          title: (
            <React.Fragment>
              <span style={{ fontSize: '12px' }}>
                AVAILABLE STOCK (Secondary)
              </span>
            </React.Fragment>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          render: (record) => (
            <div className="min-width-200">
              {['STORABLE', 'BUNDLE'].includes(
                record?.product_type?.toUpperCase(),
              ) ? (
                  <React.Fragment>
                    <div style={{ cursor: 'pointer' }}>
                      {`${QUANTITY(
                      record?.secondary_available_qty || '0',
                      record?.secondary_uom_info?.precision,
                      )} ${record?.secondary_uom_info?.uqc?.toProperCase() ?? '(N/A)'
                      }`}
                    </div>
                    {record?.other_department_secondary_quantities > 0 && (
                      <H3Text
                        text={`${QUANTITY(
                        record?.other_department_secondary_quantities || '0',
                        record?.secondary_uom_info?.precision,
                        )} ${record?.secondary_uom_info?.uqc?.toProperCase()} in other departments`}
                        className="table-subscript other-dept-stock-subscript"
                        onClick={() => {
                          setShowOtherDepartmentStock(true);
                          setSelectedProductSkuId(record?.product_sku_id);
                          setSelectedProductType(record?.product_type);
                          setSecondaryUomType('secondary');
                        }}
                      />
                    )}
                  </React.Fragment>
                ) : (
                  '-'
                )}
            </div>
          ),
          className: !visibleColumns?.SECONDARY_UOM?.visible
            ? 'display-none'
            : '',
        });
      }
      columns.push({
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        title: 'BAD STOCK IN DEFAULT DEPT',
        render: (record) => (
          <div className="min-width-180">
            {record?.product_type?.toUpperCase() === 'STORABLE' ? (
              <React.Fragment>
                <H3Text
                  text={`${QUANTITY(
                    record?.store_rejected_stock || '0',
                    record?.uom_info?.precision,
                  )} ${record?.uom_info?.uqc?.toProperCase()}`}
                />
              </React.Fragment>
            ) : (
              '-'
            )}
          </div>
        ),
        className: !visibleColumns?.REJECTED_STOCK_IN_STORE?.visible
          ? 'display-none'
          : '',
      });
      columns.push({
        title: 'STOCK STATUS ',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            {['STORABLE', 'BUNDLE'].includes(
              record?.product_type?.toUpperCase(),
            ) ? (
                <H3Text
                  text={getStockStatus(record).label}
                  className={getStockStatus(record)?.className}
                />
              ) : (
                '-'
              )}
          </div>
        ),
        className: !visibleColumns?.STORE_STOCK_STATUS?.visible
          ? 'display-none'
          : '',
      });
    }

    const otherColumns = [
      {
        title: 'BARCODE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-50">
            {record?.product_info?.barcode}
          </div>
        ),
        className:
          !visibleColumns?.BARCODE?.visible
            || !user?.tenant_info?.global_config?.sub_modules?.barcoding?.is_active
            ? 'display-none'
            : '',
      },
      {
        title: 'HSN CODE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-70">
            {record?.product_info?.hsn_code}
          </div>
        ),
        className: !visibleColumns?.HSN_CODE?.visible ? 'display-none' : '',
      },
      {
        title: 'UOM',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-50">
            {record?.uom_info?.uqc}
          </div>
        ),
        className: !visibleColumns?.UOM?.visible ? 'display-none' : '',
      },
      {
        title: 'PURCHASE UOM',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-115">
            {record?.purchase_uom_info?.uqc}
          </div>
        ),
        className: !visibleColumns?.PURCHASE_UOM?.visible ? 'display-none' : '',
      },
      {
        title: 'TAXES',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-50">
            <H3Text text={`${record?.tax_value}%`} />
          </div>
        ),
        className: !visibleColumns?.TAX?.visible ? 'display-none' : '',
      },
      {
        title: 'COST PRICE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="column-amount min-width-85">
            {MONEY(record?.cost_price)}
          </div>
        ),
        className: !visibleColumns?.COST_PRICE?.visible ? 'display-none' : '',
      },
      {
        title: 'WEIGHTED AVG PRICE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="column-amount min-width-150">
            {MONEY(record?.avg_batch_cost_price)}
          </div>
        ),
        className: !visibleColumns?.WEIGHTED_AVERAGE_COST_PRICE?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'WEIGHTED AVG LANDING',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="column-amount min-width-170">
            {MONEY(record?.avg_batch_landed_cost)}
          </div>
        ),
        className: !visibleColumns?.WEIGHTED_AVERAGE_LANDING_PRICE?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'SELLING PRICE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="column-amount min-width-100">
            {MONEY(record?.selling_price)}
          </div>
        ),
        className: !visibleColumns?.SELLING_PRICE?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'MRP',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="column-amount min-width-50">
            {MONEY(record?.mrp)}
          </div>
        ),
        className: !visibleColumns?.MRP?.visible ? 'display-none' : '',
      },
      {
        title: 'MINIMUM THRESHOLD',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-150">
            {record?.threshold_qty}
          </div>
        ),
        className: !visibleColumns?.THRESHOLD_QTY?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'SALE ENABLED',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (record?.is_sales_product ? (
          <div className="min-width-100">
            <div className="product-list__sales-status-yes" />
          </div>
        ) : (
          <div className="min-width-100">
            <div className="product-list__sales-status-no" />
          </div>
        )),
        className: !visibleColumns?.IS_SALES_ENABLED?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'PURCHASE ENABLED',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (record?.is_purchase_product ? (
          <div className="min-width-130">
            <div className="product-list__sales-status-yes" />
          </div>
        ) : (
          <div className="min-width-130">
            <div className="product-list__sales-status-no" />
          </div>
        )),
        className: !visibleColumns?.IS_PURCHASE_ENABLED?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'QC RULE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-70">
            {record?.qc_id ? record?.qcr_number : '-'}
          </div>
        ),
        className: !visibleColumns?.QC_RULE?.visible ? 'display-none' : '',
      },
      {
        title: 'PROJECTED INCOMING QTY',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-185">
            {record?.qc_id ? record?.projected_incoming_stock_qty : '-'}
          </div>
        ),
        className: !visibleColumns?.PROJECTED_INCOMING_QTY?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'PROJECTED OUTGOING STOCK',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-200">
            {record?.qc_id ? record?.projected_outgoing_stock_qty : '-'}
          </div>
        ),
        className: !visibleColumns?.PROJECTED_OUTGOING_QTY?.visible
          ? 'display-none'
          : '',
      },
      {
        title: 'PENDING QC QTY',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            {record?.qc_id ? record?.pending_in_qc_qty : '-'}
          </div>
        ),
        className: !visibleColumns?.PENDING_IN_QC_QTY?.visible
          ? 'display-none'
          : '',
      },
    ];

    columns.push(...otherColumns);
    if (customFieldsProps?.data?.document_line_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_line_custom_fields;
      customs
        ?.filter((item) => item?.is_active)
        ?.map((custom) => {
          columns.push({
            title: custom.field_name?.toUpperCase(),
            render: (record) => (
              <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
                <ViewTableCustomFields
                  customField={
                    record.custom_fields?.filter(
                      (subItem) => subItem.cf_id === custom.cf_id,
                    )?.[0]
                  }
                />
              </div>
            ),
            responsive: ['sm', 'md', 'lg', 'xxl'],
            hidden: isMobile,
            className: !visibleColumns?.[custom.cf_id]?.visible
              ? 'display-none'
              : '',
          });
        });
    }
    if (user?.tenant_info?.zoho_branch_id) {
      columns.push({
        title: '',
        key: 'action2',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => user?.user_tenants?.find(
          (item) => item?.tenant_id === record?.tenant_id,
        )?.zoho_branch_id && (
            <div>
              {record?.zoho_sku_code ? (
                <Tooltip
                  title={`Last sync ${toISTDate(record?.zoho_updated_at).format(
                    'DD/MM/YYYY hh:mm A',
                  )}`}
                  overlayClassName="font-12"
                  placement="topRight"
                >
                  <a
                    href={`https://books.zoho.in/app#/inventory/items/${record?.zoho_sku_code}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="img-zoho__wrapper">
                      <img
                        src={ZohoBooks}
                        alt="Zoho"
                        className="img-zoho"
                      />
                      <div className="green-indicator" />
                    </div>
                  </a>
                </Tooltip>
              ) : (
                <div>
                  <Popconfirm
                    placement="topRight"
                    title={
                      record?.zoho_warning_message === null
                        || record?.zoho_warning_message === ''
                        ? 'This product is not synced with Zoho Books'
                        : `${record?.zoho_warning_message}`
                    }
                    onConfirm={() => syncProduct(
                      { product_sku_id: record?.product_sku_id },
                      () => setCall(!call),
                    )}
                    okText="Sync again"
                    okButtonProps={{
                      loading: syncProductLoading,
                    }}
                    cancelText="Cancel"
                  >
                    <div className="img-zoho__wrapper">
                      <img
                        src={ZohoBooks}
                        alt="Zoho"
                        className="img-zoho img-zoho__disabled"
                      />
                      <div className="green-indicator red-indicator" />
                    </div>
                  </Popconfirm>
                </div>
              )}
            </div>
          ),
      });
    }
    if (user?.tenant_info?.shopify_location_id) {
      columns.push({
        title: '',
        key: 'action4',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => user?.user_tenants?.find(
          (item) => item?.tenant_id === record?.tenant_id,
        )?.shopify_location_id && (
            <div>
              {record?.product_info?.shopify_parent_id && (
                <Tooltip
                  title={`Last sync ${toISTDate(
                    record?.product_info?.shopify_updated_at,
                  ).format('DD/MM/YYYY hh:mm A')}`}
                  overlayClassName="font-12"
                  placement="topRight"
                >
                  <a
                    href={`https://admin.shopify.com/store/${record?.product_info?.shopify_shop_name?.split('.')?.[0]
                      }/products/${record?.product_info?.shopify_parent_id
                      }/variants/${record?.product_info?.shopify_variant_id}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="img-shopify__wrapper">
                      <img
                        src={ShopifyIcon}
                        alt="Shopify"
                        className="img-shopify"
                      />
                    </div>
                  </a>
                </Tooltip>
              )}
            </div>
          ),
      });
    }
    if (user?.tenant_info?.unicommerce_facility_code) {
      columns.push({
        title: '',
        key: 'action4',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div>
            {record?.product_info?.unicommerce_sku_code && (
              <Tooltip
                title={
                  record?.product_info?.unicommerce_updated_at
                    ? `Last sync ${toISTDate(
                      record?.product_info?.unicommerce_updated_at,
                    ).format('DD/MM/YYYY hh:mm A')}`
                    : 'Synced with Unicommerce'
                }
                overlayClassName="font-12"
                placement="topRight"
              >
                <a
                  href={`https://${user?.tenant_info?.unicommerce_domain_name}.unicommerce.com/products/edit?sku=${record?.product_info?.unicommerce_sku_code}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="img-shopify__wrapper">
                    <img
                      src={ucIcon}
                      alt=""
                      className="unicommerce-button"
                    />
                  </div>
                </a>
              </Tooltip>
            )}
          </div>
        ),
      });
    }
    columns.push({
      title: '',
      key: 'action',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isPortrait,
      render: (text, record) => (
        <div className="list__actions">
          <Link
            to={`/inventory/product/view/${record.product_sku_id}?tab=/general-information`}
          >
            <div className="list__actions-button">View</div>
          </Link>

          {Helpers.getPermission(
            Helpers.permissionEntities.PURCHASE_ORDER,
            Helpers.permissionTypes.CREATE,
            user,
          ) && (
            <div className="list__actions">
              <RecentTransactions
                className="list__actions-button"
                tenantId={user?.tenant_info?.tenant_id}
                productSkuId={record?.product_sku_id}
                productSkuName={record?.product_info?.product_sku_name}
                internalSkuCode={record?.internal_sku_code}
                refProductCode={record?.ref_product_code}
              />
            </div>
          )}
          {(Helpers.getPermission(
            Helpers.permissionEntities.PURCHASE_REQUEST,
            Helpers.permissionTypes.CREATE,
            user,
          )
            || Helpers.getPermission(
              Helpers.permissionEntities.PURCHASE_ORDER,
              Helpers.permissionTypes.CREATE,
              user,
            )) && (
            <div
              className="list__actions-button"
              onClick={() => {
                const payload = {
                  tenant_id: user.tenant_info?.tenant_id,
                  product_sku_ids: [record?.product_sku_id],
                };
                if (!record?.alreadyInCart && record?.is_purchase_product) {
                  addToCartV2(payload, () => {
                    setIsDropdownVisible(false);
                    getCartV2({ tenantId: user?.tenant_info?.tenant_id });
                    setSelectedRowKeys(null);
                    setSelectedRows(null);
                  });
                }
              }}
            >
              {record?.alreadyInCart ? (
                <Tooltip title="Already in cart">
                  <FontAwesomeIcon
                    icon={faCartPlus}
                    color="rgb(47, 188, 110)"
                  />
                </Tooltip>
              ) : (
                <React.Fragment>
                  {
                    !record?.is_purchase_product ? (
                      <Tooltip title="Product is not purchase enabled">
                        <FontAwesomeIcon icon={faCartPlus} color="gray" />
                      </Tooltip>
                    ) : (
                      <FontAwesomeIcon icon={faCartPlus} />
                    )
                  }
                </React.Fragment>
              )}
            </div>
          )}
        </div>
      ),
      fixed: 'right',
      className: 'list__actions-column',
    });
    return columns.filter((item) => !item.hidden);
  };

  const getStockStatus = (record) => {
    const avlQty = record?.department_quantity;
    if (avlQty >= record?.threshold_qty && record?.threshold_qty !== 0) {
      return {
        label: 'Well Stocked',
        className: 'product_stock-status__stocked',
      };
    }
    if (avlQty > record?.threshold_qty && record?.threshold_qty === 0) {
      return {
        label: 'Well Stocked',
        className: 'product_stock-status__stocked',
      };
    }
    if (avlQty < record?.threshold_qty && avlQty > 0) {
      return { label: 'Running Low', className: 'product_stock-status__low' };
    }
    return { label: 'Out of Stock', className: 'product_stock-status__ooo' };
  };

  const getProductsWithKey = (productsData) => {
    const storeAllProductsSkuIds = cartDataV2?.result?.products?.map(
      (product) => product.product_sku_id,
    );
    const productsCopy = JSON.parse(JSON.stringify(productsData));
    for (let i = 0; i < productsCopy?.length; i++) {
      if (storeAllProductsSkuIds?.includes(productsCopy[i].product_sku_id)) {
        productsCopy[i].alreadyInCart = true;
      } else {
        productsCopy[i].alreadyInCart = false;
      }
      productsCopy[i].key = i;
    }
    return productsCopy;
  };

  const pushParamsToUrl = (
    currentKeyword,
    status,
    stockType,
    productCategory,
    page,
    limit,
    sortBy,
    selectedMarketplaceProduct,
    departmentId,
    advanceFilters,
    selectedFilterView,
  ) => {
    let url = '?tab=/products-list';
    if (page) url += `&page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (currentKeyword) url += `&keyword=${currentKeyword}`;
    if (status) url += `&status=${status}`;
    if (stockType) url += `&product_type=${stockType}`;
    if (productCategory.length) url += `&category=${productCategory}`;
    if (sortBy) url += `&sort_by=${sortBy}`;
    if (selectedMarketplaceProduct) url += `&marketplace_product=${selectedMarketplaceProduct}`;
    if (departmentId) url += `&department_id=${departmentId}`;
    if (advanceFilters) url += `&advance_filter=${advanceFilters}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView.filter_id}`;

    history.push(url);
  };

  // to get the category name from category id
  const findCategoryNameById = (categories, id) => {
    if (!categories) return null; // Ensure categories is not undefined
    for (const category of categories) {
      if (category.product_category_id === id) {
        return category.product_category_name;
      }
      if (category.sub_categories) {
        const subCategoryName = findCategoryNameById(
          category.sub_categories,
          id,
        );
        if (subCategoryName) {
          return subCategoryName;
        }
      }
    }
    return null; // Return null if no matching category is found
  };

  const barCoding = user?.tenant_info?.global_config?.sub_modules?.barcoding?.is_active;
  const onMenuClick = (e) => {
    if (e.key === '1' || e.key === 1) {
      setShowBulkImportDrawer(true);
      setBulkUploadProducts(true);
    } else if (e.key === '2' || e.key === 2) {
      setShowBulkImportDrawer(true);
      setBulkUploadProducts(false);
    }
  };
  const items = [
    {
      key: '1',
      label: 'Upload New Products',
    },
    {
      key: '2',
      label: 'Update Existing Products',
    },
  ];

  return (
    <Fragment>
      <Drawer
        open={showAddProductModal}
        width="720px"
        mask
        onClose={() => setShowAddProductModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header">
            <H3Text text="Add New Product" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setShowAddProductModal(false)}
            />
          </div>
        </div>
        <ProductForm
          callback={() => {
            setShowAddProductModal(false);
            setCall(!call);
          }}
        />
      </Drawer>
      <Drawer
        open={showUpdateProductModal}
        width="720px"
        mask
        onClose={() => setShowUpdateProductModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header">
            <H3Text text="Update Product" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setShowUpdateProductModal(false)}
            />
          </div>
        </div>
        <ProductForm
          callback={() => {
            setShowUpdateProductModal(false);
            setCall(!call);
          }}
        />
      </Drawer>
      <div className="doc-list__wrapper doc-list__tab-content">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search with product name or SKU code.."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => setKeyword(event.target.value)}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(
                  Helpers.permissionEntities.PRODUCT,
                  Helpers.permissionTypes.CREATE,
                  user,
                ) && (
                  <div className="doc-list__buttons-wrapper">
                    {/* <PRZButton
                      onClick={() => {
                        setShowAddProductModal(true);
                        getDocCFV2Success(null);
                      }}
                      wrapperStyle={{ marginRight: "8px" }}
                      buttonStyle={{ width: "120px" }}
                    >
                      <div>+ Add Product</div>
                    </PRZButton> */}
                    <H3Button
                      text="+ Add Products"
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      onClick={() => {
                        setShowAddProductModal(true);
                        getDocCFV2Success(null);
                      }}
                      customClass="add-button hide__in-mobile"
                    />
                    <Dropdown
                      overlay={<Menu items={items} onClick={onMenuClick} />}
                      trigger={['hover']}
                      open={visible}
                      onOpenChange={handleVisibleChange}
                    >
                      {/* <PRZButton
                        buttonStyle={{ width: "140px" }}
                      >
                        <div> + Upload Products</div>
                      </PRZButton> */}
                      <H3Button
                        text="+ Upload Products"
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        onClick={() => { setVisible(!visible); }}
                        customClass="add-button hide__in-mobile"
                      />
                    </Dropdown>
                  </div>
                )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;

                    setKeyword(tempFilterValues.keyword);
                    setSearchKeyword(tempFilterValues.keyword);
                    setCurrentPageSize(tempFilterValues.limit || currentPageSize);
                    setCurrentPage(1);
                    setSelectedStatus(tempFilterValues.status);
                    setSelectedType(tempFilterValues.product_type);
                    setSortBy(tempFilterValues.sort_by);
                    setSelectedDepartment(tempFilterValues.department_id);
                    setMarketplaceProduct(tempFilterValues.marketplace_product);
                    setSelectedCategory(tempFilterValues.category);
                    setAdvanceFilters(tempFilterValues.advance_filter);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.PRODUCTS}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {sortBy && (
                  <Tag
                    closable
                    onClose={() => {
                      setSortBy('');
                    }}
                    color="#2d7df7"
                  >
                    Sort By - &nbsp;
                    <b>
                      <div className="flex-display">
                        {
                          sortConfig.find((item) => item?.value === sortBy)
                            ?.label
                        }
                        <div style={{ marginLeft: '5px' }}>
                          {sortConfig.find((item) => item?.value === sortBy)
                            ?.mode === 'desc' ? (
                              <ArrowDownOutlined />
                            ) : (
                              <ArrowUpOutlined />
                            )}
                        </div>
                      </div>
                    </b>
                  </Tag>
                )}
                {searchKeyword && (
                  <Tag
                    closable
                    onClose={() => {
                      setSearchKeyword('');
                      setKeyword('');
                      setCurrentPage(1);
                    }}
                    color="#2d7df7"
                  >
                    Search for &nbsp;
                    <span>
                      <b>{searchKeyword}</b>
                    </span>
                  </Tag>
                )}
                {selectedStatus && (
                  <Tag
                    closable
                    onClose={() => {
                      setSelectedStatus(null);
                      setCurrentPage(1);
                    }}
                    color="#2d7df7"
                  >
                    Status - &nbsp;
                    <span>
                      <b>
                        {selectedStatus?.replaceAll('_', ' ')?.toUpperCase()}
                      </b>
                    </span>
                  </Tag>
                )}
                {selectedDepartment && selectedDepartment !== 'all' && (
                  <Tag
                    Tag
                    closable={
                      Helpers.getTenantDepartmentId(user)
                      === user?.tenant_info?.default_store_id
                      || showOtherDepartmentStockConfig
                    }
                    onClose={() => {
                      setSelectedDepartment('all');
                      setCurrentPage(1);
                    }}
                    color="#2d7df7"
                  >
                    {' '}
                    Department - &nbsp;
                    <span>
                      <b>
                        {departments?.data?.result?.departments
                          ?.find(
                            (item) => Number(item?.department_id)
                              === Number(selectedDepartment),
                          )
                          ?.department_info?.department_name?.toUpperCase()}
                      </b>
                    </span>
                  </Tag>
                )}
                {selectedType && (
                  <Tag
                    closable
                    onClose={() => {
                      setSelectedType(null);
                      setCurrentPage(1);
                    }}
                    color="#2d7df7"
                  >
                    Product Type - &nbsp;
                    <span>
                      <b>{selectedType?.replaceAll('_', ' ')?.toUpperCase()}</b>
                    </span>
                  </Tag>
                )}
                {selectedCategory
                  && selectedCategory.map((item, index) => {
                    const categoryName = subCategories
                      ? findCategoryNameById(subCategories, item)
                      : null;
                    return (
                      <Tag
                        key={index}
                        closable
                        onClose={() => {
                          setCurrentPage(1);
                          setSelectedCategory(
                            selectedCategory.filter((_, i) => i !== index),
                          );
                        }}
                        color="#2d7df7"
                      >
                        Category - &nbsp;
                        <span>
                          <b>{categoryName?.toUpperCase() || ''}</b>
                        </span>
                      </Tag>
                    );
                  })}
                {advanceFilters?.length > 0 && (
                  <Tag closable onClose={() => { setAdvanceFilters(''); setCurrentPage(1); }} color="#2d7df7">
                    Advanced Filters
                  </Tag>
                )}
              </div>
            </div>
            {user && (
              <div className="doc-list__table-wrapper">
                <Table
                  title={() => (
                    <div className="doc-list__table-header">
                      <div className="doc-list__table-header__left">
                        <H3Text
                          text={`${products && products.count ? products.count : '0'
                            } Products In Your Inventory`}
                          className=""
                        />
                      </div>
                      <div className="doc-list__table-header__right">
                        <div className="doc-list__filter-buttons">
                          {selectedRowKeys?.length > 0 && (
                            <Dropdown
                              overlay={(
                                <div className="custom-columns__sort-filter">
                                  <H3Text
                                    text="Calculate SP"
                                    className="header__custom-dropdown__option"
                                    onClick={() => {
                                      setShowSpCalculationDrawer(true);
                                    }}
                                  />
                                  <H3Text
                                    text="Bulk Update"
                                    className="header__custom-dropdown__option"
                                    onClick={() => {
                                      setShowBulkUpdateProducts(true);
                                    }}
                                  />
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <H3Text
                                      text="Print Barcodes"
                                      className="header__custom-dropdown__option"
                                      onClick={() => {
                                        if (barCoding) {
                                          setShowPrintBarcodeDrawer(true);
                                        }
                                      }}
                                    />
                                    {!barCoding && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => window.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img
                                          className="barcode-restrict"
                                          src={Crown}
                                          alt="premium"
                                        />
                                      </Popconfirm>
                                    )}
                                  </div>
                                  {(Helpers.getPermission(
                                    Helpers.permissionEntities.PURCHASE_REQUEST,
                                    Helpers.permissionTypes.CREATE,
                                    user,
                                  )
                                    || Helpers.getPermission(
                                      Helpers.permissionEntities.PURCHASE_ORDER,
                                      Helpers.permissionTypes.CREATE,
                                      user,
                                    )) && (
                                    <H3Text
                                      text="Add to cart"
                                      className="header__custom-dropdown__option"
                                      onClick={() => {
                                        const enableForPurchase = selectedRows?.filter(
                                          (item) => item?.is_purchase_product,
                                        );
                                        const notEnableForPurchase = selectedRows?.filter(
                                          (item) => !item?.is_purchase_product,
                                        );
                                        const allReadyInCart = enableForPurchase?.filter(
                                          (item) => item?.alreadyInCart,
                                        );
                                        const notInCart = enableForPurchase?.filter(
                                          (item) => !item?.alreadyInCart,
                                        );
                                        const tempSelectedProductSkuId = notInCart?.map(
                                          (item) => item?.product_sku_id,
                                        );
                                        const payload = {
                                          tenant_id:
                                              user.tenant_info?.tenant_id,
                                          product_sku_ids:
                                              tempSelectedProductSkuId,
                                        };
                                        addToCartV2(payload, () => {
                                          // Set dropdown visibility to false
                                          setIsDropdownVisible(false);
                                          // Fetch the updated cart information
                                          getCartV2({
                                            tenantId:
                                                user?.tenant_info?.tenant_id,
                                          });
                                          // Clear selected rows
                                          setSelectedRowKeys(null);
                                          setSelectedRows(null);
                                          // Trigger success notification
                                          notification.success({
                                            message: (
                                              <div>
                                                {allReadyInCart.length > 0 && (
                                                  <div
                                                    style={{ color: 'green' }}
                                                  >
                                                    {allReadyInCart.length}
                                                    {' '}
                                                    products already in cart.
                                                  </div>
                                                )}
                                                {notInCart.length > 0 && (
                                                  <div
                                                    style={{ color: 'gray' }}
                                                  >
                                                    {notInCart.length}
                                                    {' '}
                                                    products
                                                    added to cart successfully.
                                                  </div>
                                                )}
                                                {notEnableForPurchase.length
                                                    > 0 && (
                                                  <div style={{ color: 'red' }}>
                                                    {
                                                      notEnableForPurchase.length
                                                    }
                                                    {' '}
                                                    could not be added because
                                                    product is not purchase
                                                    enabled.
                                                  </div>
                                                )}
                                              </div>
                                            ),
                                            placement: 'top',
                                            duration: 4,
                                          });
                                        });
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                              trigger={['click']}
                              placement="bottomRight"
                              visible={isDropdownVisible}
                              onVisibleChange={(flag) => setIsDropdownVisible(flag)}
                            >
                              <div
                                className="custom-columns__wrapper"
                              >
                                Actions
                                <CaretDownFilled />
                              </div>
                            </Dropdown>
                          )}
                        </div>
                        <div
                          className="doc-list__action-buttons"
                          onClick={() => {
                            setOpenProductFiltersDrawer(true);
                          }}
                        >
                          <div className="action-button">
                            <H3Text
                              text="Filters"
                              className="action-button-text"
                            />
                            <FilterOutlined />
                          </div>
                        </div>
                        <React.Fragment>
                          <Drawer
                            open={openProductFiltersDrawer}
                            width={openAdvanceProductFiltersDrawer ? '1050px' : '420px'}
                            mask
                            onClose={() => setOpenProductFiltersDrawer(false)}
                            destroyOnClose
                            className={openAdvanceProductFiltersDrawer ? 'product__filter-drawer' : ''}
                          >
                            <div className="custom-drawer__header-wrapper">
                              <div
                                className="custom-drawer__header"
                                style={{ width: '370px' }}
                              >
                                <H3Text
                                  text="Apply Filters"
                                  className="custom-drawer__title"
                                />
                                <H3Image
                                  src={closeIcon}
                                  className="custom-drawer__close-icon"
                                  onClick={() => setOpenProductFiltersDrawer(false)}
                                />
                              </div>
                            </div>
                            <ProductFilterDrawer
                              user={user}
                              selectedStatus={selectedStatus}
                              setSelectedStatus={setSelectedStatus}
                              selectedType={selectedType}
                              setSelectedType={setSelectedType}
                              selectedCategory={selectedCategory}
                              setSelectedCategory={setSelectedCategory}
                              marketplaceProduct={marketplaceProduct}
                              setMarketplaceProduct={setMarketplaceProduct}
                              setCurrentPage={setCurrentPage}
                              setSelectedDepartment={setSelectedDepartment}
                              selectedDepartment={selectedDepartment}
                              depFilterDisableCase={
                                Helpers.getTenantDepartmentId(user)
                                !== user?.tenant_info?.default_store_id
                                && !showOtherDepartmentStockConfig
                              }
                              openAdvanceProductFiltersDrawer={
                                openAdvanceProductFiltersDrawer
                              }
                              setOpenAdvanceProductFiltersDrawer={
                                setOpenAdvanceProductFiltersDrawer
                              }
                            />
                            <Drawer
                              open={openAdvanceProductFiltersDrawer}
                              width="820px"
                              mask
                              onClose={() => setOpenAdvanceProductFiltersDrawer(false)}
                              destroyOnClose
                            >
                              <div className="custom-drawer__header-wrapper">
                                <div className="custom-drawer__header" style={{ width: '770px' }}>
                                  <H3Text text="Apply Advance Filters" className="custom-drawer__title" />
                                  <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOpenAdvanceProductFiltersDrawer(false)} />
                                </div>
                              </div>
                              <AdvanceFilter
                                customFieldOptions={customFieldOptions}
                                advanceFilters={advanceFilters}
                                setAdvanceFilters={setAdvanceFilters}
                                setOpenAdvanceProductFiltersDrawer={setOpenAdvanceProductFiltersDrawer}
                                setOpenProductFiltersDrawer={setOpenProductFiltersDrawer}
                                customKey="prz-advance-filter-product"
                              />
                            </Drawer>
                          </Drawer>
                        </React.Fragment>
                        <React.Fragment>
                          <Drawer
                            open={moreDetailsDrawer}
                            mask
                            onClose={() => setMoreDetailsDrawer(false)}
                            destroyOnClose
                            rootClassName="mobile__more-details_wrapper"
                          >
                            <div className="custom-drawer__header-wrapper">
                              <div
                                className="custom-drawer__header"
                              >
                                <H3Text
                                  text={`${selectedProduct?.product_sku_name} - ${selectedProduct?.internal_sku_code}`}
                                  className="custom-drawer__title"
                                />
                                <H3Image
                                  src={closeIcon}
                                  className="custom-drawer__close-icon"
                                  onClick={() => setMoreDetailsDrawer(false)}
                                />
                              </div>
                            </div>
                            <MoreInfoMobileView
                              description={selectedProduct?.description}
                              customFields={selectedProduct?.custom_fields}
                              fields={ListScreenKeys({ documentData: selectedProduct, MONEY, priceMasking })}
                            />
                          </Drawer>
                        </React.Fragment>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text
                                  text="Visible Columns"
                                  className="custom-columns__content-title"
                                />
                                {Object.keys(visibleColumns)
                                  .filter(
                                    (item) => visibleColumns[item]?.visible,
                                  )
                                  ?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(
                                            JSON.stringify(visibleColumns),
                                          );
                                          visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                          localStorage.setItem(
                                            'prcz-page-columns-product',
                                            JSON.stringify(visibleColumnsCopy),
                                          );

                                          setVisibleColumns(
                                            visibleColumnsCopy,
                                          );
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))}
                              </div>
                              {Object.keys(visibleColumns).filter(
                                (item) => !visibleColumns[item]?.visible,
                              )?.length ? (
                                  <div className="custom-columns__content-section">
                                    <H3Text
                                      text="Hidden Columns"
                                      className="custom-columns__content-title"
                                    />
                                    {Object.keys(visibleColumns)
                                      .filter(
                                        (item) => !visibleColumns[item]?.visible,
                                      )
                                      ?.map((key) => (
                                        <div key={key}>
                                          <Checkbox
                                            disabled={fixedColumns.includes(
                                              key,
                                            )}
                                            checked={
                                            visibleColumns[key]?.visible
                                            }
                                            onChange={() => {
                                              const visibleColumnsCopy = JSON.parse(
                                                JSON.stringify(visibleColumns),
                                              );
                                              visibleColumnsCopy[key].visible = !visibleColumnsCopy[key]
                                                .visible;
                                              localStorage.setItem(
                                                'prcz-page-columns-product',
                                                JSON.stringify(
                                                  visibleColumnsCopy,
                                                ),
                                              );
                                              setVisibleColumns(
                                                visibleColumnsCopy,
                                              );
                                            }}
                                          >
                                            {visibleColumns[key]?.label}
                                          </Checkbox>
                                        </div>
                                      ))}
                                  </div>
                                ) : (
                                  ''
                                )}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__sort-filter">
                              {sortConfig?.map((item) => (
                                <H3Text
                                  text={(
                                    <div className="sort-by__dropdown-option">
                                      {item?.label}
                                      <div className="arrow">
                                        {item?.mode === 'desc' ? (
                                          <ArrowDownOutlined />
                                        ) : (
                                          <ArrowUpOutlined />
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  className={`header__custom-dropdown__option ${sortBy === item?.value
                                    ? 'header__custom-dropdown__option-selected'
                                    : ''
                                    }`}
                                  onClick={() => setSortBy(item?.value)}
                                />
                              ))}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Sort By
                            <SwapOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  )}
                  loading={
                    getProductsLoading
                    || getCartLoading
                    || syncProductLoading
                    || getCFV2Loading
                    || addToCartLoadingV2
                    || savedFilterViewsLoading
                  }
                  showHeader
                  size="small"
                  scroll={!isMobileOrPortrait && products && products?.result?.products && !!getProductsWithKey(products?.result?.products)?.length
                    ? { x: 'max-content', y: 'calc(100dvh - 180px)' } : { x: 'max-content' }}
                  sticky={!isMobileOrPortrait && products && products?.result?.products && !!getProductsWithKey(products?.result?.products)?.length}
                  columns={getProductColumns()}
                  bordered
                  dataSource={
                    products && products?.result?.products
                      ? getProductsWithKey(products?.result?.products)
                      : []
                  }
                  pagination={
                    {
                      current: currentPage,
                      total: products ? products.count : 0,
                      pageSize: currentPageSize,
                      position: ['bottomLeft'],
                      showSizeChanger: true,
                      showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                      onChange: (page, pageSize) => {
                        setCurrentPage(page);
                        setCurrentPageSize(pageSize);
                      },
                      pageSizeOptions: ['10', '25', '50', '100'],
                    }
                  }
                  rowClassName={(record) => (cart?.data?.cartData?.filter(
                    (item) => item?.tenantProductId === record?.tenant_product_id,
                  )?.length
                    ? 'inventory__table__selected-cart-row'
                    : '')}
                  rowSelection={
                    !isMobile
                      ? {
                        onChange: (rowKeys, rows) => {
                          setSelectedRowKeys(rowKeys);
                          setSelectedRows(rows);
                        },
                        selectedRowKeys,
                      }
                      : false
                  }
                />
              </div>
            )}
          </div>
        </div>
        {selectedProductType !== 'BUNDLE' && (
          <Drawer
            placement="right"
            onClose={() => {
              setShowOtherDepartmentStock(false);
              setSecondaryUomType('');
            }}
            open={showOtherDepartmentStock}
            width="360px"
            destroyOnClose
          >
            <div className="custom-drawer__header-wrapper">
              <div className="custom-drawer__header" style={{ width: '310px' }}>
                <H3Text
                  text="Stock in Other Departments"
                  className="custom-drawer__title"
                />
                <H3Image
                  src={closeIcon}
                  className="custom-drawer__close-icon"
                  onClick={() => {
                    setShowOtherDepartmentStock(false);
                    setSecondaryUomType('');
                  }}
                />
              </div>
            </div>
            <OtherDepartmentsStock
              selectedProductSkuId={selectedProductSkuId}
              tenantId={user?.tenant_info?.tenant_id}
              uomType={uomType}
            />
          </Drawer>
        )}
        <Drawer
          placement="right"
          onClose={() => setShowPrintBarcodeDrawer(false)}
          open={showPrintBarcodeDrawer}
          width="360px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '310px' }}>
              <H3Text text="Print Barcodes" className="custom-drawer__title" />
              <H3Image
                src={closeIcon}
                className="custom-drawer__close-icon"
                onClick={() => setShowPrintBarcodeDrawer(false)}
              />
            </div>
          </div>
          <PrintBarcodes selectedRows={selectedRows} barcodeType="PRODUCT" />
        </Drawer>
        <Drawer
          placement="right"
          onClose={() => setShowSpCalculationDrawer(false)}
          open={showSpCalculationDrawer}
          width="1050px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '1000px' }}>
              <H3Text
                text={`Calculate Selling Prices for ${selectedRows?.length} Products`}
                className="custom-drawer__title"
              />
              <H3Image
                src={closeIcon}
                className="custom-drawer__close-icon"
                onClick={() => setShowPrintBarcodeDrawer(false)}
              />
            </div>
          </div>
          <CalculateBulkSp
            selectedRows={selectedRows}
            callback={() => {
              setCall(!call);
              setShowSpCalculationDrawer(false);
            }}
          />
        </Drawer>
        <Drawer
          placement="right"
          onClose={() => setShowBulkImportDrawer(false)}
          open={showBulkImportDrawer}
          width="745px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '700px' }}>
              <H3Text
                text={
                  bulkUploadProducts ? 'Import products' : 'Update Products'
                }
                className="custom-drawer__title"
              />
              <H3Image
                src={closeIcon}
                className="custom-drawer__close-icon"
                onClick={() => setShowBulkImportDrawer(false)}
              />
            </div>
          </div>
          <BulkImportProducts
            isBulkUploadProducts={bulkUploadProducts}
            callback={() => {
              setShowBulkImportDrawer(false);
              setCall(!call);
            }}
          />
        </Drawer>

        <Drawer
          placement="right"
          onClose={() => setShowBulkUpdateProducts(false)}
          open={showBulkUpdateProducts}
          width="1045px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '1000px' }}>
              <H3Text
                text={`Update ${selectedRows?.length} Products`}
                className="custom-drawer__title"
              />
              <H3Image
                src={closeIcon}
                className="custom-drawer__close-icon"
                onClick={() => setShowBulkUpdateProducts(false)}
              />
            </div>
          </div>
          <BulkUpdateProducts
            callback={() => {
              setShowBulkUpdateProducts(false);
              setCall(!call);
            }}
            selectedRows={selectedRows}
          />
        </Drawer>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers,
  ProductReducers,
  SellerReducers,
  CategoryReducers,
  OfferReducers,
  CartReducers,
  ZohoIntegrationReducers,
  CFV2Reducers,
  AddToCartReducers,
  DepartmentReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  products: ProductReducers.products,
  getProductsLoading: ProductReducers.getProductsLoading,
  getSellersLoading: SellerReducers.getSellersLoading,
  sellers: SellerReducers.sellers,
  updateSellerOffersLoading: SellerReducers.updateSellerOffersLoading,
  addProductVendorLoading: ProductReducers.addProductVendorLoading,
  productOffers: ProductReducers.productOffers,
  getOffersLoading: OfferReducers.getOffersLoading,
  offers: OfferReducers.offers,
  cart: CartReducers.cart,
  getCartLoading: CartReducers.getCartLoading,
  syncProductLoading: ZohoIntegrationReducers.syncProductLoading,
  getCFV2Loading: CFV2Reducers.getCFV2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocProducts,
  subCategories: CategoryReducers.subCategories,
  addToCartLoadingV2: AddToCartReducers.addToCartLoadingV2,
  cartDataV2: AddToCartReducers.cartDataV2,
  departments: DepartmentReducers.departments,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getProducts: (
    keyword,
    tenantId,
    stockStatus,
    limit,
    page,
    tenantDepartmentId,
    excludeOutOfStock,
    productType,
    category,
    isSalesProduct,
    isPurchaseProduct,
    search,
    sortBy,
    filterReservedQuantity,
    barcode,
    isShopifyProduct,
    isMarketplaceProduct,
    departmentId,
    advanceFilters,
    isListScreen,
  ) => dispatch(
    ProductActions.getProducts(
      keyword,
      tenantId,
      stockStatus,
      limit,
      page,
      tenantDepartmentId,
      excludeOutOfStock,
      productType,
      category,
      isSalesProduct,
      isPurchaseProduct,
      search,
      sortBy,
      filterReservedQuantity,
      barcode,
      isShopifyProduct,
      isMarketplaceProduct,
      departmentId,
      advanceFilters,
      isListScreen,
    ),
  ),
  setDefaultOffer: (payload, callback) => dispatch(ProductActions.setDefaultOffer(payload, callback)),
  getOffers: (tenantProductId, tenantSellerId) => dispatch(OfferActions.getOffers(tenantProductId, tenantSellerId)),
  getCart: (tenantId) => dispatch(CartActions.getCart(tenantId)),
  getDocCFV2Success: (customFieldsDocV2) => dispatch(CFV2Actions.getDocCFV2Success(customFieldsDocV2)),
  syncProduct: (payload, callback) => dispatch(ZohoIntegrationActions.syncProduct(payload, callback)),
  getSubCategories: (searchKeyword, page, limit) => dispatch(CategoryActions.getSubCategories(searchKeyword, page, limit)),
  addToCartV2: (payload, callback) => dispatch(AddToCartActions.addToCartV2(payload, callback)),
  getCartV2: (payload, callback) => dispatch(AddToCartActions.getCartV2(payload, callback)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ProductsList));
